import { CabalPermissionName } from 'src/@types/Permission';
import {
  PermissionDeniedMessage,
  PermissionDeniedMessageProps,
} from 'src/components/PermissionDeniedMessage';
import { usePermissions } from 'src/hooks/usePermissions';

type Props = {
  permissions: CabalPermissionName[];
  children: React.ReactNode;
  hasContent?: boolean;
  permissionMessageProps?: PermissionDeniedMessageProps;
};

export const PermissionGuard: React.FC<Props> = ({
  permissions,
  hasContent,
  children,
  permissionMessageProps,
}) => {
  const { can } = usePermissions();

  if (!can(permissions)) {
    return hasContent ? (
      <PermissionDeniedMessage {...permissionMessageProps} />
    ) : null;
  }

  return <>{children}</>;
};
